// extracted by mini-css-extract-plugin
export var mainContent = "styles-module--main-content--335de";
export var subtitle = "styles-module--subtitle--61d33";
export var title = "styles-module--title--66599";